<form aria-label="Site search" class="search-form" role="search">
    <input
        [coreAutoFocus]="autoFocus"
        [formControl]="queryField"
        autocomplete="off"
        class="search-form__input form-control"
        id="search"
        [placeholder]="'Search' | translate"
        tabindex="0"
        type="text" />

    <label class="search-form__label" for="search">
        <span class="sr-only">Search</span>
        <span class="material-symbols-outlined search-icon search-form__icon">search</span>
    </label>

    <!-- Clear search input-->
    @if (search.showClearButton) {
        <button (click)="resetSearch()" aria-label="Clear" class="btn-close btn--search-clear" type="button">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    }
</form>
